import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { SEND_EMAIL_EXCEL } from "../config/api";
import Profile from "../components/Profile";

export default function EmailForm() {
  const [subject, setSubject] = useState("Test Subject {recipientName}");
  const [body, setBody] = useState(
    "<h1>Hello, {recipientName}!</h1><p>Your unique ID is <b>{recipientId}</b>.</p><p>Thank you for joining us!</p>"
  );
  const [mailHost, setMailHost] = useState("smtp.gmail.com");
  const [recipientsFile, setRecipientsFile] = useState(null);
  const [sendersFile, setSendersFile] = useState(null);
  const { profileData } = Profile();

  const handleFileUpload = (setter) => (e) => {
    const file = e.target.files[0];
    setter(file);
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = new FormData();
    payload.append("mailHost", mailHost);
    payload.append("subject", subject);
    payload.append("body", body);
    payload.append("employeeId", profileData.id);
    if (recipientsFile) payload.append("recipientsFile", recipientsFile);
    if (sendersFile) payload.append("sendersFile", sendersFile);

    try {
      const response = await axios.post(
        `${SEND_EMAIL_EXCEL + profileData.id}`,
        payload,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setLoading(false);
      alert("Email sent successfully");
      console.log("Email sent successfully:", response.data);
    } catch (error) {
      console.error(
        "Error sending email:",
        error.response ? error.response.data : error.message
      );
    }
  };

  return (
    <div className="row">
      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Send Email</h4>
            <form className="forms-sample" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Subject</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label>Body</label>
                <ReactQuill theme="snow" value={body} onChange={setBody} />
              </div>
              <div className="form-group">
                <label>Mail Host</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Mail Host"
                  value={mailHost}
                  onChange={(e) => setMailHost(e.target.value)}
                  required
                />
              </div>
              <div className="row form-group">
                <div className="col-md-6">
                  <label>Upload Recipients File</label>
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileUpload(setRecipientsFile)}
                    className="form-control mt-2"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label>Upload Senders File</label>
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileUpload(setSendersFile)}
                    className="form-control mt-2"
                    required
                  />
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-success mr-2"
                disabled={loading}
              >
                {loading ? (
                  <div
                    className="spinner-border spinner-border-sm text-light"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  "Send"
                )}
              </button>

              <button type="submit" className="btn btn-dark">
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
